import { CartControllerAddResponseErrorTypeEnum } from '@redteclab/api/clients/bully'

type CartIntermediateLabelKey =
  | CartControllerAddResponseErrorTypeEnum
  | 'cart.notification.addedItem'
  | 'cart.notification.missingOrderDraft'
  | 'cartintermediate.drawer.error.title'

export const CART_INTERMEDIATE_LABELS: Partial<
  Record<CartIntermediateLabelKey, string>
> = {
  'cart.notification.addedItem': 'cart.notification.addedItem',
  'cart.notification.missingOrderDraft': 'cart.notification.missingOrderDraft',
  [CartControllerAddResponseErrorTypeEnum.PutMpEntryToCartWithOds]:
    'cart.intermediate.cantMixMiraklAndODSProducts',
  [CartControllerAddResponseErrorTypeEnum.PutMpEntryToErxCardWithErx]:
    'cart.intermediate.cantMixMiraklAndERXProducts',
  'cartintermediate.drawer.error.title': 'cartintermediate.drawer.error.title',
}
